import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const NavbarPublic = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-20 items-center">
                    {/* Logo */}
                    <div className="flex-shrink-0 flex items-center">
                        <Link to="/" className="flex items-center space-x-2">
                            <div className={`${scrolled ? 'bg-gray-900' : 'bg-white/10 backdrop-blur-md border border-white/20'} p-2 rounded-lg transition-colors duration-300`}>
                                <svg className={`h-6 w-6 ${scrolled ? 'text-white' : 'text-amber-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                </svg>
                            </div>
                            <span className={`font-bold text-2xl tracking-tight font-serif transition-colors duration-300 ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                                Innventory<span className={`${scrolled ? 'text-amber-600' : 'text-amber-400'}`}>AI</span>
                            </span>
                        </Link>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        <a href="#features" className={`${scrolled ? 'text-gray-600 hover:text-gray-900' : 'text-gray-300 hover:text-white'} font-bold transition-colors uppercase text-sm tracking-widest`}>Features</a>
                        <a href="#pricing" className={`${scrolled ? 'text-gray-600 hover:text-gray-900' : 'text-gray-300 hover:text-white'} font-bold transition-colors uppercase text-sm tracking-widest`}>Pricing</a>
                        <div className="flex items-center space-x-4 ml-4">
                            <Link to="/login" className={`${scrolled ? 'text-gray-900' : 'text-white'} font-bold hover:text-amber-500 transition-colors uppercase text-sm tracking-widest`}>
                                Sign in
                            </Link>
                            <Link to="/signup" className={`${scrolled ? 'bg-gray-900 hover:bg-gray-800 text-white' : 'bg-amber-500 hover:bg-amber-400 text-gray-900 hover:shadow-[0_0_20px_-3px_rgba(251,191,36,0.6)]'} px-6 py-2.5 font-bold transition-all rounded-lg uppercase text-sm tracking-widest border border-transparent`}>
                                Get Started
                            </Link>
                        </div>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden flex items-center">
                        <button onClick={() => setIsOpen(!isOpen)} className={`${scrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white hover:text-gray-300'} focus:outline-none transition-colors`}>
                            {isOpen ? <XMarkIcon className="h-6 w-6" /> : <Bars3Icon className="h-6 w-6" />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden bg-white/95 backdrop-blur-md shadow-lg absolute w-full px-4 pt-2 pb-6 space-y-2 border-b border-gray-100">
                    <a href="#features" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsOpen(false)}>Features</a>
                    <a href="#how-it-works" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsOpen(false)}>How it Works</a>
                    <a href="#pricing" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsOpen(false)}>Pricing</a>
                    <div className="mt-4 pt-4 border-t border-gray-100 flex flex-col space-y-3">
                        <Link to="/login" className="block text-center text-gray-900 font-medium hover:text-indigo-600" onClick={() => setIsOpen(false)}>
                            Sign in
                        </Link>
                        <Link to="/signup" className="block text-center bg-indigo-600 text-white px-4 py-3 font-medium hover:bg-indigo-700" onClick={() => setIsOpen(false)}>
                            Get Started
                        </Link>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default NavbarPublic;
